import React from "react";
import PropTypes from "prop-types";
import {
  Label,
  LabelText,
  Required,
  Input,
  Salary,
  SalaryElement,
  Error,
} from "../styles/form-styles";

const Contract = ({ salaryMin, handleTextInput, errors, currency }) => (
  <Salary>
    <SalaryElement>
      <Label htmlFor="salary-min">
        <LabelText>
          Day Rate in {currency.symbol} <Required>*</Required>
        </LabelText>
      </Label>
      <Input
        onKeyDown={(evt) => evt.key === "e" && evt.preventDefault()}
        type="number"
        name="salaryMin"
        id="salary-min"
        value={salaryMin}
        onChange={(e) => handleTextInput(e)}
      />
      {errors.salaryMin && <Error>Required field.</Error>}
    </SalaryElement>
  </Salary>
);

Contract.propTypes = {
  salaryMin: PropTypes.string,
  handleTextInput: PropTypes.func.isRequired,
  errors: PropTypes.shape({
    salaryMin: PropTypes.number,
  }).isRequired,
  currency: PropTypes.shape({
    symbol: PropTypes.string.isRequired,
    isoCode: PropTypes.string.isRequired,
  }),
};

Contract.defaultProps = {
  salaryMin: PropTypes.isNull,
  currency: {
    symbol: null,
    currency: null,
  },
};

export default Contract;
